'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {

	CHANGE: 'FACETS_CHANGE',

	UPDATE: 'FACETS_UPDATE'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/facets/action-types.js
// module id = 756
// module chunks = 0